export function scrollPageToTop() {
  const scroll = () => {
    window.scrollTo(0, 0);
    const scrollingElement = document.scrollingElement;
    if (scrollingElement) scrollingElement.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  };

  scroll();
  requestAnimationFrame(scroll);
  window.setTimeout(scroll, 0);
}

export function getTotalPages(totalProducts, pageSize, page, hasNext) {
  if (typeof totalProducts === "number" && totalProducts > 0 && pageSize > 0) {
    return Math.max(1, Math.ceil(totalProducts / pageSize));
  }
  if (hasNext) return Math.max(page + 1, 1);
  return Math.max(page, 1);
}
